class GiftOption extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('.product-gift-option__toggle');
    this.commentWrapper = this.querySelector('[data-gift-comment]');
    this.textarea = this.commentWrapper && this.commentWrapper.querySelector('textarea');

    if (!this.toggle || !this.textarea) return;

    this.sync = this.sync.bind(this);
    this.toggle.addEventListener('change', this.sync);
    this.sync();
  }

  sync() {
    const enabled = this.toggle.checked;
    this.commentWrapper.hidden = !enabled;
    this.textarea.disabled = !enabled;
  }
}

if (!customElements.get('gift-option')) {
  customElements.define('gift-option', GiftOption);
}
